<template>
    <ul v-if="tabs.length" class="tab-buttons-container" :aria-label="ariaLabelForTabsContainer">
      <li v-for="tab in tabs">
        <button class="btn" type="button" :ref="tab.id" :key="'key-'+tab.id" @click="clickMethod(tab.id)" :aria-label="tab.tabButtonAriaLabel">
          {{ tab.tabButtonText }}
        </button>
      </li>
    </ul>
</template>
<script>

export default {
  name: "Tabs",
  props: {
    tabsContentListId: String,
    ariaLabelForTabsContainer: String,
  },
  data: function () {
    return {
      tabs: [],
    };
  },
  created() {
    var tabContentList = this.modifyTabContentList();
    if (tabContentList) {
      for (var i = 0; i < tabContentList.children.length; i++) {
        var tabContent = tabContentList.children[i];
        var rawTabdata = tabContent.getAttribute("data-tabdata");
        var tabdata = JSON.parse(rawTabdata);
        Object.assign(tabdata, {"id": tabContent.getAttribute("id")});
        this.tabs.push(tabdata);
      }
    }
  },
  mounted() {
    this.clickMethod(this.tabs[0].id, false);
  },
  methods: {
    clickMethod(tabId, isNormalClick = true) {
      this.tabs.forEach(tab => {
        var tabContent = this.getTabContentElement(tab.id);
        if(tabContent) {
          tabContent.className = "d-none";
        }

        var tabBtn = this.getTabButtonElement(tab.id);
        if(tabBtn) {
          tabBtn.classList.remove("active");
          tabBtn.setAttribute("aria-current", "false");
        }
      });

      var tabContent = this.getTabContentElement(tabId);
      if(tabContent) {
        tabContent.className = "";

        if(isNormalClick) {
          tabContent.focus();
        }

        var tabBtn = this.getTabButtonElement(tabId);
        if(tabBtn) {
          tabBtn.classList.add("active");
          tabBtn.setAttribute("aria-current", "true");
        }
      }
    },
    getTabContentElement(tabId) {
      return document.getElementById(tabId);
    },
    getTabButtonElement(tabId) {
      return this.$refs[tabId][0];
    },
    modifyTabContentList() {
      var tabContentList = document.getElementById(this.tabsContentListId);
      if (!tabContentList) {
        return null;
      }

      tabContentList.querySelectorAll(".temp").forEach(tempElem => {
        if (tempElem) {
          tempElem.remove();
        }
      });

      for (var i = 0; i < tabContentList.children.length; i++) {
        var tabContent = tabContentList.children[i];
        if (tabContent.tagName === "LI" && tabContent.hasAttribute("data-tabdata")) {
          tabContent = convertElementToDiv(tabContent);
          tabContent.id = `${this.tabsContentListId}-${i}`;
        }
        else
        {
          tabContent.remove();
        }
      }
      return convertElementToDiv(tabContentList);

      function convertElementToDiv(elem) {
        var newElem = document.createElement("div");
        
        [...elem.childNodes].forEach(child => {
          newElem.appendChild(child);
        });

        elem.getAttributeNames().forEach(name => {
          if (!name.startsWith("aria-")) {
            newElem.setAttribute(name, elem.getAttribute(name));
          }
        });

        elem.parentNode.replaceChild(newElem, elem);
        return newElem;
      }
    },
  }
};
</script>